import { collectionTips } from "@/mocks/home";

export default function CollectionSection() {
  return (
    <section id="collect" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="rounded-lg overflow-hidden border border-background-200/70">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="relative min-h-[280px] lg:min-h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cozy%20desk%20scene%20with%20a%20laptop%20showing%20a%20bookmark%20save%20icon%2C%20notebook%20and%20coffee%20cup%2C%20soft%20natural%20light%2C%20clean%20minimal%20editorial%20photography%2C%20gentle%20red%20accent%20tones%2C%20calm%20inviting%20atmosphere&width=1200&height=900&seq=cherry-collect-2026-b2&orientation=squarish"
                  alt="把网站地址收藏备份的桌面场景"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>

              <div className="bg-background-50 p-6 md:p-10">
                <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
                  <i className="ri-bookmark-3-line"></i>
                  收藏与提醒
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
                  多留一份备份，就不会走失
                </h2>
                <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  地址可能变化，但你收藏本页的习惯可以一直保留。用下面几种方式给自己多留几份备份，
                  无论换设备还是清缓存，都能重新找回入口。
                </p>

                <ul className="mt-6 space-y-3">
                  {collectionTips.map((tip, idx) => (
                    <li key={tip} className="flex gap-3 items-start">
                      <span className="mt-0.5 w-6 h-6 shrink-0 rounded-md bg-primary-100 text-primary-700 text-xs font-medium flex items-center justify-center">
                        {idx + 1}
                      </span>
                      <span className="text-sm text-foreground-700 leading-relaxed">{tip}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#address"
                  className="mt-8 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-arrow-up-line"></i>
                  前往复制本页链接
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}